import { render, staticRenderFns } from "./FestivalPreview.vue?vue&type=template&id=533cebe6"
import script from "./FestivalPreview.vue?vue&type=script&lang=js"
export * from "./FestivalPreview.vue?vue&type=script&lang=js"
import style0 from "./FestivalPreview.vue?vue&type=style&index=0&id=533cebe6&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533cebe6')) {
      api.createRecord('533cebe6', component.options)
    } else {
      api.reload('533cebe6', component.options)
    }
    module.hot.accept("./FestivalPreview.vue?vue&type=template&id=533cebe6", function () {
      api.rerender('533cebe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FestivalPreview.vue"
export default component.exports